/**
 * TEMPORARY program data.
 *
 * Used by `useIndustryPrograms` (src/lib/programs.js) only while the backend
 * `/programs` endpoint does not return programs for an industry. Once the
 * backend is populated, set USE_MOCK_FALLBACK to false in src/lib/programs.js
 * and delete this file.
 *
 * The 15 virtual internships match industry pages (see src/data/programDetails.js), including AI/CS and Engineering.
 * Shape = raw backend shape (see docs/ENGINEERING_GUIDE.md, "Programs API
 * contract"). It goes through `normalizeProgram` like real API data.
 */

const IMG = {
  medical: "https://alearninglab.com/wp-content/uploads/2025/05/Medical-01.webp",
  tech: "https://alearninglab.com/wp-content/uploads/2025/05/VI-01.webp",
  business: "https://alearninglab.com/wp-content/uploads/2025/08/Stanford-004.png",
  law: "https://alearninglab.com/wp-content/uploads/2025/05/Law-01.webp",
};

export const PROGRAMS_MOCK = [
  {
    id: "mock-medicine-and-healthcare",
    slug: "medicine-and-healthcare-virtual-internship",
    industry: "health",
    title: "Medicine & Healthcare Virtual Internship",
    summary:
      "Step into the world of medicine through clinical scenarios, shadowing doctors, and developing skills in patient care, clinical reasoning, and understanding how real healthcare systems function.",
    thumbnail: IMG.medical,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    featured: true,
    url: "/programs/medicine-and-healthcare-virtual-internship",
  },
  {
    id: "mock-psychology-and-human-behaviour",
    slug: "psychology-and-human-behaviour-virtual-internship",
    industry: "health",
    title: "Psychology & Human Behaviour Virtual Internship",
    summary:
      "Explore the science of human behaviour through real-world scenarios while building skills in observation, empathy, behavioural analysis, and decision-making to understand how people think, feel, and act.",
    thumbnail: IMG.medical,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "/programs/psychology-and-human-behaviour-virtual-internship",
  },
  {
    id: "mock-healthtech",
    slug: "healthtech-virtual-internship",
    industry: "health",
    title: "Healthtech Virtual Internship",
    summary:
      "Discover how technology is transforming healthcare by analyzing data, designing solutions, and building skills in problem-solving, innovation, and understanding how digital tools shape healthcare systems.",
    thumbnail: IMG.medical,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "/programs/healthtech-virtual-internship",
  },
  {
    id: "mock-dentistry",
    slug: "dentistry-virtual-internship",
    industry: "health",
    title: "Dentistry Virtual Internship",
    summary:
      "Step into the world of dentistry through real, stage-by-stage patient cases – developing skills in diagnosis, patient communication, and treatment planning that compound week over week.",
    thumbnail: IMG.medical,
    mode: "Virtual",
    duration: "3 Weeks",
    price: 300,
    currency: "USD",
    url: "/programs/dentistry-virtual-internship",
  },
  {
    id: "mock-ui-ux-product-design",
    slug: "ui-ux-product-design-virtual-internship",
    industry: "ui-ux-creative-designing",
    title: "UI/UX Product Design Virtual Internship",
    summary:
      "Design digital experiences by learning tools like Figma, conducting user research, and building prototypes while developing skills in visual design, usability, problem-solving, and creating intuitive, user-centered products.",
    thumbnail: IMG.tech,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    featured: true,
    url: "/programs/ui-ux-product-design-virtual-internship",
  },
  {
    id: "mock-architecture-and-design",
    slug: "architecture-and-design-virtual-internship",
    industry: "ui-ux-creative-designing",
    title: "Architecture & Design Virtual Internship",
    summary:
      "Explore how spaces are designed by applying design thinking, sustainability principles, and spatial planning while building skills in creativity, problem-solving, and understanding architecture, interiors, and urban design.",
    thumbnail: IMG.tech,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "/programs/architecture-and-design-virtual-internship",
  },
  {
    id: "mock-gaming-and-vr",
    slug: "gaming-and-vr-virtual-internship",
    industry: "gaming-innovation",
    title: "Gaming & VR Virtual Internship",
    summary:
      "Create immersive game experiences by designing gameplay, exploring VR tools, and building interactive projects while developing skills in storytelling, logic, user experience, and understanding how games are built professionally.",
    thumbnail: IMG.tech,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    featured: true,
    url: "/programs/gaming-and-vr-virtual-internship",
  },
  {
    id: "mock-aviation",
    slug: "aviation-virtual-internship",
    industry: "gaming-innovation",
    title: "Aviation Virtual Internship",
    summary:
      "Explore the world of aviation through simulations, case studies, and real scenarios while building skills in navigation, operations, problem-solving, and understanding how pilots, engineers, and airports function together.",
    thumbnail: IMG.tech,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "/programs/aviation-virtual-internship",
  },
  {
    id: "mock-finance-and-venture-capital",
    slug: "finance-and-venture-capital-virtual-internship",
    industry: "finance",
    title: "Finance & Venture Capital Virtual Internship",
    summary:
      "Learn how money drives businesses by analyzing financial statements, valuing companies, and exploring real deals while building skills in financial reasoning, investment thinking, and strategic decision-making used by…",
    thumbnail: IMG.business,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    featured: true,
    url: "/programs/finance-and-venture-capital-virtual-internship",
  },
  {
    id: "mock-fintech",
    slug: "fintech-virtual-internship",
    industry: "finance",
    title: "Fintech Virtual Internship",
    summary:
      "Understand how digital finance works by using real tools, analyzing transactions, and designing solutions while building skills in budgeting, cybersecurity, problem-solving, and understanding how technology transforms modern…",
    thumbnail: IMG.business,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "/programs/fintech-virtual-internship",
  },
  {
    id: "mock-entrepreneurship-and-innovation",
    slug: "entrepreneurship-and-innovation-virtual-internship",
    industry: "business-marketing",
    title: "Entrepreneurship & Innovation Virtual Internship",
    summary:
      "Build your own venture idea by validating ideas, conducting market research, and creating prototypes while developing skills in problem-solving, business strategy, customer understanding, and launching real-world products.",
    thumbnail: IMG.business,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    featured: true,
    url: "/programs/entrepreneurship-and-innovation-virtual-internship",
  },
  {
    id: "mock-marketing-and-brand-strategy",
    slug: "marketing-and-brand-strategy-virtual-internship",
    industry: "business-marketing",
    title: "Marketing & Brand Strategy Virtual Internship",
    summary:
      "Learn how brands grow by creating campaigns, using AI tools, and analyzing audiences while building skills in storytelling, content creation, digital strategy, and data-driven marketing decision-making.",
    thumbnail: IMG.business,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "/programs/marketing-and-brand-strategy-virtual-internship",
  },
  {
    id: "mock-lawyer",
    slug: "lawyer-virtual-internship",
    industry: "law-public-policy-global-affairs",
    title: "Lawyer Virtual Internship",
    summary:
      "Step into the legal world by analyzing real cases, building arguments, and participating in mock trials while developing skills in legal reasoning, advocacy, critical thinking, and understanding modern legal systems.",
    thumbnail: IMG.law,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    featured: true,
    url: "/programs/lawyer-virtual-internship",
  },
  {
    id: 328,
    slug: "ai-and-computer-science-virtual-internship",
    industry: "technology-and-engineering",
    title: "AI & Computer Science Virtual Internship",
    summary:
      "Explore how intelligent systems are designed and built through live projects, coding and AI concepts guided by industry mentors.",
    thumbnail: IMG.tech,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "https://alearninglab.com/virtual-internships/ai-computer-science-shadowing/",
  },
  {
    id: 329,
    slug: "engineering-virtual-internship",
    industry: "technology-and-engineering",
    title: "Engineering Virtual Internship",
    summary:
      "Understand how engineering shapes the world by exploring mechanical, civil, electrical and chemical concepts while building design and problem-solving skills.",
    thumbnail: IMG.tech,
    mode: "Virtual",
    duration: "6 Weeks",
    price: 300,
    currency: "USD",
    url: "https://alearninglab.com/engineering-virtual-shadowing-program/",
  },
];
